function formatE164Digits(digits) {
  if (digits.startsWith("971")) {
    return `(+971) ${digits.slice(3)}`;
  }

  if (digits.startsWith("20")) {
    return `(+20) ${digits.slice(2)}`;
  }

  return `+${digits}`;
}

/** Western digits, no spaces — same format in EN and AR. */
export function formatPhoneDisplay(e164) {
  const digits = String(e164 || "").replace(/\D/g, "");
  if (!digits) return "";

  return formatE164Digits(digits);
}
